const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  materialList: state => state.material.list,
  language: state => state.app.language,
  
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js